/** translate--fr */

import * as config from '../config.js';

const fr = {
	key: 'fr',
	MATH: {
		FRACTION: '.'
	},
	APPLY: 'valider',
	HTML: {
		title: 'Configurateur Lif',
		dsTitle: 'Lif - Fiche technique'
	},
	FINISH: {
		INFO: 'Choisir un type de finition et cliquer sur appliquer.',
		HEADER: 'Finition',
		seluxGraphite: 'Selux graphite',
		ral9005: 'noir profond',
		ral7016: 'gris anthracite',
		ral7024: 'gris graphite',
		ral7011: 'gris fer',
		ral9007: 'aluminium gris',
		ral9006: 'aluminium blanc',
		ral9010: 'blanc pur',
		ral9016: 'blanc trafic',
		ral6009: 'vert sapin',
		ral6005: 'vert mousse',
		ral5003: 'bleu saphir',
		ral3005: 'rouge vin',
		ral3003: 'rouge rubis',
		db703: 'Pearled dark grey',
		db702: 'Pearled silver grey',
		db701: 'Pearled white aluminium'
	},
	STEPS: {
		FINISHED: 'terminé',
		NEXT: 'suivant',
		scope: 'sélectionner un type d\'application',
		config: 'configuration',
		zoom: 'configuration', // the same as config:
		parameters: 'distribution photométrique',
		height: 'hauteur de la colonne Lif', //'height over all',
		upload: 'configuration', // the same as config:
		foto: 'télécharger une image d\'arrière-plan',
		summary: 'sommaire',
		datasheet: 'finaliser la configuration'
	},
	// INFO: see translate-info*.js
	INFOBOX: {
		parameters: 'distribution photométrique',
		height: 'hauteur de la colonne', //'height over all',
		element: 'module top, balisage ou base',
		inset: 'module spot ou façade',
		elements: 'module top, balisage ou base',
		insets: 'module spot ou façade',
		charging: 'borne de recharge',
		chargings: 'bornes de recharge'
	},
	SCOPE: {
		HEADING: 'Sélectionner un type d\'applications.',
		0: 'Illumination de façade',
		1: 'Eclairage de place',
		2: 'Eclairage d\'accentuation',
		3: 'Eclairage de rue',
		length: 4
	},
	PRODUCTS: {
		baseDescription: {
			// see belowW
		},
		description: {
			// see below
		},
		datasheet: {
			// see below
		}
	},
	DATASHEET: {
		LINKTEXT: 'Finaliser la configuration et créer la fiche technique',
		SHORTDESC: 'Ensemble Lif configuré',
		OPENING: 'Profil en aluminium extrudé, embouts de terminaison en fonderie d\'aluminium. ',
		FACADE: 'Le module façade est en fonderie d\'aluminium. ',
		TOP: 'Le module top est fonderie d\'aluminium avec un cylindre de fermeture clair en PMMA. ',
		MOUNTING: 'Les modules base peuvent s\'installer les uns sur les autres et s\'orienter de manière totalement indépendante dans toutes les directions de 0 à 360°. Ils sont disponibles avec un couvercle de fermeture arrière en option. ',
		TWINSPOT: 'Le module spot est en fonderie d\'aluminium avec verre trempé sérigraphié. Chaque projecteur est inclinable indépendamment de l\'autre de ±45°. ',
		RGBW: 'Le module balisage est en fonderie d\'aluminium et dispose d\'une partie diffusante en PMMA. ',
		CLOSING: 'L\'élément support est un mât en acier galvanisé avec une plaque de fixation pour modules Lif. Chaque élément principal est équipé de LED 3000 ou 4000 K. ',
		FABRICATE: 'Fabrication: Selux,',
		COLOUR: 'Finition:',
		COLORING: 'Selux graphite ou thermolaquage Ral ou Futura, couleur au choix',
		DIAMETER: 'Diametre  Ø: ',
		HEIGHT: 'Hauteur H: ',
		WEIGHT: 'Poids: ',
		WINDAGE: 'SCx: ',
		CONTACTINTRO: 'Pour plus de précisions, ou pour toute demande spéciale non gérée par ce configurateur, veuillez contacter votre représentant commercial habituel.',
		CHANGING: 'Ces données sont susceptibles d\'être modifiées compte -tenu des changements apportés aux produits en fonction des évolutions de la technologie LED.', // FIXME fr translation DATASHEET.CHANGING
		CHANGES: ' Données sujettes à modification ',
		REQUESTPRICE: 'sur demande',
		HEADING_MOUNTED: 'Structures',
		HEADING_MODULES: 'Modules',
		HEADING_POLE: 'Mât',
		HEADING_ACCESSORIES: 'Accessoires',
		HEADING_HEIGHT: 'Hauteur ',
		COL_COUNT: 'Quantité',
		COL_SX: 'N° art.',
		COL_DESCRIPTION: 'Description',
		COL_SINGLE_PRICE: 'Prix*',
		COL_TOTAL_PRICE: 'Montant*',
		TOTAL: 'Prix barème H.T. à lumière configurée*',
		TOTAL_HEIGHT: 'Hauteur total',
		PRICEINFO: '*Les prix s\'entendent hors montage, hors taxes.',
		LISTCAPTION: 'Configuration du luminaire',
		CONF_ID: 'Configuration du luminaire'
	},
	STELE: {
		DISTRIBUTION: 'distribution photométrique', // Lichtverteilung
		BACKCOVER: 'couvercle arrière de fermeture', //Optionale Abdeckung für Rückseite
		F_WIDE: 'extensif', // Breit
		F_NARROW: 'intensif', // Eng
		W_SYM: 'symétrique', // Wege Lichtverteilung
		W_ASYM: 'asymétrique', // Wege Lichtverteilung
		W_SILVER: 'argent',
		W_GOLD: 'doré',
		C_BOSCH: 'plaque d\'adaptation pour\nBosch FLEXIDOME IP outdoor 5000',
		C_AXIS: 'plaque d\'adaptation pour\nAxis Dome P322X',
		C_ENEO: 'plaque d\'adaptation pour\neneo dome IPD-73M2812M0A',
		RENDERING_DOWNLAOD: 'télécharger',
		SHOW_HEAD: 'Modules',
		SHOW_BOTTOM: 'Station de recharge pour mât',
		CHARGING_BASIC: 'Basique',
		CHARGING_ADV: 'Avancé',
		CHARGING_PROF: 'Professionnel',
		CHARGING_DOOR: 'Porte'
	},
	FOTO: { // from Astro
		CHANGE: 'changer de décors',
		RESET: 'retour',
		UPLOAD: 'télécharger une image',
		EDIT: 'éditer l\'image',
		ADD: 'ajouter un luminaire',
		ACCEPT: 'changer de luminaire',
		DOWNLOAD: 'télécharger la simulation'
	},
	UPLOAD: { // from Astro
		UPLOAD: 'Choisir le fichier à télécharger',
		UPLOADBUTTON: 'Choisir le fichier',
		ACCEPT: 'accepter',
		CANCEL: 'annuler',
		ERROR: 'Erreur, le téléchargement a échoué',
		WORKING: 'Téléchargement en cours'
	},
	SUMMARY: {
		TITEL: 'Vue générale de l\'ensemble configuré',
		BASE_CONFIGURATION: 'élément de support / mât',
		HEIGHT: 'hauteur:',
		CABLEBOX: 'boîte à fusibles',
		EXTRADOORS: 'deuxième porte pour mât',
		EXTRADOORS2: 'troisième porte pour mât',
		CHARGING_BASIC: 'Basique',
		CHARGING_ADV: 'Avancé',
		CHARGING_PROF: 'Professionnel',
		CAM: 'avec plaque d\'adaptation pour',
		C_BOSCH: '\nBosch FLEXIDOME IP\noutdoor 5000 série',
		C_AXIS: '\nAxis caméra dôme P322X série',
		C_ENEO: '\neneo network dome IPD-73M2812M0A',
	},
	USER: { //TODO USER translations
		LOGIN_TEXT: 'Connexion',
		LOGIN_BUTTON: 'Connexion',
		LOGOUT_BUTTON: 'Déconnexion',
		USERNAME: 'Identifiant',
		PASSWORD: 'Mot de passe',
		LOAD_TEXT: 'Déconnexion',
		LOAD_BUTTON: 'Chargement',
		PRICES_TEXT: 'Afficher les prix'
	}
};

// fr with calculated key

fr.PRODUCTS.baseDescription[config.PART_BASIS_NAME] = 'embase mât';
fr.PRODUCTS.baseDescription[config.PART_DECKEL_NAME] = 'couvercle de fermeture';
fr.PRODUCTS.baseDescription[config.PART_MODUL_RGBW_NAME] = 'module balisage';
fr.PRODUCTS.baseDescription[config.PART_MODUL_WEGE_NAME] = 'module top quadruple';
fr.PRODUCTS.baseDescription[config.PART_MODUL_WEGE2_NAME] = 'module top double';
fr.PRODUCTS.baseDescription[config.PART_MODUL_AUFNAHME_500_NAME] = 'module base 500';
fr.PRODUCTS.baseDescription[config.PART_MODUL_AUFNAHME_250_NAME] = 'module base 250';
fr.PRODUCTS.baseDescription[config.PART_MODUL_AUFNAHME_1000_NAME] = 'module base 1000';
fr.PRODUCTS.baseDescription[config.PART_MODUL_AUFNAHME_1500_NAME] = 'module base 1500';
fr.PRODUCTS.baseDescription[config.PART_MODUL_KAMERA_NAME] = 'module camera';
fr.PRODUCTS.baseDescription[config.PART_MODUL_WLAN_NAME] = 'module WiFi';
fr.PRODUCTS.baseDescription[config.PART_ELEMENT_SPEAKER_NAME] = 'module haut-parleur';
fr.PRODUCTS.baseDescription[config.PART_ELEMENT_VERT_NAME] = 'module sentier';
fr.PRODUCTS.baseDescription[config.PART_ELEMENT_TWINSPOT_NAME] = 'module spot';
fr.PRODUCTS.baseDescription[config.PART_ELEMENT_FASSADE_500_NAME] = 'module façade';
fr.PRODUCTS.baseDescription[config.PART_ELEMENT_GOBO_NAME] = 'module gobo';
fr.PRODUCTS.baseDescription[config.PART_MODUL_CHARGING_NAME] = 'borne de recharge';

fr.PRODUCTS.description[config.PART_BASIS_NAME] = 'embase mât';
fr.PRODUCTS.description[config.PART_DECKEL_NAME] = 'couvercle de fermeture';
fr.PRODUCTS.description[config.PART_MODUL_RGBW_NAME] = 'module balisage';
fr.PRODUCTS.description[config.PART_MODUL_WEGE_NAME] = 'module top\nquadruple';
fr.PRODUCTS.description[config.PART_MODUL_WEGE2_NAME] = 'module top\ndouble';
fr.PRODUCTS.description[config.PART_MODUL_AUFNAHME_500_NAME] = 'module base 500 pour\nmodule spot ou façade';
fr.PRODUCTS.description[config.PART_MODUL_AUFNAHME_250_NAME] = 'module base 250 pour\nmodule spot';
fr.PRODUCTS.description[config.PART_MODUL_AUFNAHME_1000_NAME] = 'module base 1000 pour\nmodule spot ou façade';
fr.PRODUCTS.description[config.PART_MODUL_AUFNAHME_1500_NAME] = 'module base 1500 pour\nmodule spot ou façade';
fr.PRODUCTS.description[config.PART_MODUL_KAMERA_NAME] = 'module camera';
fr.PRODUCTS.description[config.PART_MODUL_WLAN_NAME] = 'module WiFi';
fr.PRODUCTS.description[config.PART_ELEMENT_SPEAKER_NAME] = 'module haut-parleur';
fr.PRODUCTS.description[config.PART_ELEMENT_VERT_NAME] = 'module sentier';
fr.PRODUCTS.description[config.PART_ELEMENT_TWINSPOT_NAME] = 'module spot';
fr.PRODUCTS.description[config.PART_ELEMENT_FASSADE_500_NAME] = 'module façade';
fr.PRODUCTS.description[config.PART_ELEMENT_GOBO_NAME] = 'module gobo';
fr.PRODUCTS.description[config.PART_MODUL_CHARGING_NAME] = 'borne de recharge';

export default fr;
